// src/services/authService.ts
import { http } from "./http";
import { setBasicAuth, clearBasicAuth } from "./authStorage";
import { setSessionUser, clearSessionUser } from "./sessionStorage";

export type LoginRequest = {
  email: string;
  password: string;
};

export type LoginResponse = {
  ok: boolean;
  nombre: string;
  email: string;
  roles: string[];
};

function buildBasic(email: string, password: string) {
  return `Basic ${btoa(`${email}:${password}`)}`;
}

export async function login(payload: LoginRequest) {
  const res = await http.request<LoginResponse>("/api/auth/login", {
    method: "POST",
    body: payload,
    auth: "none",
  });

  if (!res.ok) throw new Error("Credenciales inválidas");

  setBasicAuth(buildBasic(payload.email, payload.password));
  setSessionUser({ nombre: res.nombre, email: res.email, roles: res.roles });

  return res;
}

export function logout() {
  clearBasicAuth();
  clearSessionUser();
}